import { FIRM_ADDRESS_LINE } from '../utils/pdfBranding';

/**
 * The neutral landing for a client host whose URL has been trimmed.
 *
 * His words, 2026-09-20: a client who trims `portal.apex-res.com/portal/<token>` down to the bare
 * host currently reaches the APEX STAFF LOGIN. That is what this page replaces.
 *
 * ⛔ IT OFFERS NO WAY INTO THE APP - no login link, no navigation, no staff host named. A client
 * landing here should understand they need the link they were sent and nothing more. Adding a
 * "staff sign in" link here would restore the exact thing it exists to remove.
 *
 * ⛔ No support phone or address beyond the firm line the documents already carry. Inventing a
 * support number a client might actually ring is worse than telling them to reply to the person
 * who sent the link.
 */
export default function ClientHome() {
  return (
    <div className="max-w-xl mx-auto p-6 sm:p-8">
      <h1 className="font-display text-[28px] font-semibold uppercase leading-[1.06] tracking-[-.01em] text-gray-900 sm:text-[32px]">
        Apex Real Estate Services
      </h1>
      <p className="mt-4 text-sm leading-relaxed text-gray-600">
        This address serves the secure document links we send to clients. There is nothing to
        browse here.
      </p>
      <div className="mt-6 rounded-lg bg-gray-50 p-4">
        <p className="text-sm leading-relaxed text-gray-700">
          To reach your documents, open the full link you were sent. It will look like this
          address followed by a code.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-gray-700">
          If your link has stopped working, reply to the person who sent it and they will issue a
          new one.
        </p>
      </div>
      <p className="mt-8 text-center text-xs text-gray-400">{FIRM_ADDRESS_LINE}</p>
    </div>
  );
}
